import { VIDEO_PRIVACY_PUBLIC } from '../constants/video';

export const isPrivateOrPasswordProtectedVideo = video =>
  isPrivate(video) || hasPassword(video) || video.is_protected;

export const isPublicVideo = video => !isPrivateOrPasswordProtectedVideo(video);

export const isPrivate = video =>
  video.privacy !== null &&
  video.privacy !== undefined &&
  video.privacy !== VIDEO_PRIVACY_PUBLIC;

export const hasPassword = video =>
  video.password !== null && video.password !== undefined;

export const viewersCanWeaveVideo = video => video.getViewersCanWeave();

export const getRecordingVersion = video =>
  video.get('video_properties').recording_version;

export const shouldFilterSensitiveData = (video, isOwner) => {
  if (
    video.viewer_needs_permission === undefined ||
    video.needs_password === undefined
  ) {
    throw new Error(
      'shouldFilterSensitiveData can only be used on video objects with viewer_needs_permission and needs_password defined'
    );
  }

  return !isOwner && (video.viewer_needs_permission || video.needs_password);
};

export const isCurrentUserOwner = (video, user) =>
  video.currentUserIsOwner(user);
